import type {
  SettingsPageContextProps,
  SettingsPageContextServices,
} from '../../../types';
import { fetchCurrentMember } from '../viewer-controller/state';
import { handleNavigation, redirectToErrorPage } from './navigation';
import {
  addInitialDataForWidgetPlugins,
  emitMemberChangedEventToPlugins,
} from './widget-plugins';

export const addLoginHandler = (
  contextProps: SettingsPageContextProps,
  contextServices: SettingsPageContextServices,
) => {
  return contextProps.wixCodeApi.user.onLogin(async () => {
    try {
      await fetchCurrentMember(contextProps, contextServices);
    } catch (error) {
      contextServices.monitoringService.reportError(error as Error);
      return redirectToErrorPage(contextProps, contextServices, error);
    }

    addInitialDataForWidgetPlugins(contextProps, contextServices);
    await emitMemberChangedEventToPlugins(contextProps, contextServices);
    await contextServices.multiStateBoxService.showMainAppState();
    await handleNavigation(contextProps, contextServices);
  });
};
